import { render, staticRenderFns } from "./AdvisorCategory.vue?vue&type=template&id=45ce7b36&scoped=true&"
import script from "./AdvisorCategory.vue?vue&type=script&lang=js&"
export * from "./AdvisorCategory.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorCategory.vue?vue&type=style&index=0&id=45ce7b36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce7b36",
  null
  
)

export default component.exports